import { DatastoreProvider, InstanceStack } from 'component/navigation/instance';
import { useInstanceConfig } from 'data/instance-config';
import { useLocalSearchParams } from 'expo-router';

const moduleFn = () => import('feature/account/account-module');

export default function AccountLayout() {
    const { siloKey } = useLocalSearchParams<'/[siloKey]/account/one'>();
    const instanceConfig = useInstanceConfig({
        siloKey,
        structureKey: 'account',
        instanceKey: 'one',
        moduleFn,
    });
    return (
        <DatastoreProvider {...instanceConfig}>
            <InstanceStack />
        </DatastoreProvider>
    );
}
